export const pageContainer = {
  minHeight: "100vh",
  backgroundColor: "#EEF2F7",
  padding: "60px 20px 8rem",
  display: "flex",
  justifyContent: "center",
};

export const cardContainer = {
  width: "min(1200px, 96vw)",
  backgroundColor: "#fff",
  borderRadius: 12,
  padding: 40,
  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
};

export const title = {
  textAlign: "center",
  marginBottom: "30px",
  color: "#1E3A8A",
  fontWeight: "800",
};

export const selectRow = {
  marginBottom: "30px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  flexWrap: "wrap",
};

export const typeSelectStyle = {
  padding: "10px 15px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: "15px",
  width: "280px",
  background: "#fff",
};

export const thStyle = {
  padding: "10px 8px",
  border: "1px solid #ccc",
  textAlign: "center",
  fontWeight: "700",
  fontSize: "14px",
};

export const tdStyle = {
  border: "1px solid #ddd",
  padding: "8px 10px",
  backgroundColor: "#fafafa",
};

export const tdEmpty = {
  textAlign: "center",
  padding: "10px",
  color: "#777",
  backgroundColor: "#f9f9f9",
  border: "1px solid #ddd",
};

export const selectStyle = {
  width: "70px",
  padding: "4px",
  borderRadius: "5px",
  border: "1px solid #ccc",
  textAlign: "center",
  margin: "0 auto",
  display: "block",
};

export const inputTextStyle = {
  width: "100%",
  border: "none",
  outline: "none",
  background: "transparent",
};

export const buttonStyle = {
  backgroundColor: "#2563EB",
  color: "white",
  padding: "8px 16px",
  borderRadius: "6px",
  border: "none",
  fontWeight: "600",
  cursor: "pointer",
};

export const miniButton = {
  backgroundColor: "#2563EB",
  color: "white",
  border: "none",
  borderRadius: "6px",
  padding: "8px 10px",
  cursor: "pointer",
  fontWeight: "600",
};

export const pagerRow = {
  marginTop: "30px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "15px",
};

export const pagerInfo = { fontWeight: "600", color: "#1E3A8A" };